import React from 'react'
import './styles.css'

export const LandingLayout = ({ children: Component, ...rest }) => {
  const responsiveStyles = {
    containerLeft: {
      backgroundColor: '#ffffff',
      height: window.innerHeight,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    containerRight: {
      backgroundImage: `url('/pattern01.jpg')`,
      height: window.innerHeight,
      backgroundColor: 'white',
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
    },
  }

  const styles = {
    logo: {
      marginBottom: 80,
    },
    quotes: {
      position: 'absolute',
      color: '#ffffff',
      fontFamily: 'Open Sans',
    },
    quotesOne: {
      fontSize: 32,
    },
    quotesTwo: {
      fontSize: 41,
      fontWeight: 'bold',
    },
    quotesThree: {
      marginTop: 30,
      fontSize: 28,
    },
    landingFooter: {
      background: 'none',
      bottom: '0',
      left: '0',
      padding: '10px 20px',
      position: 'absolute',
      right: '0',
    },
  }
  return (
    <div style={{ display: 'flex' }}>
      <div className='col-sm-5' style={responsiveStyles.containerLeft}>
        <div className='landing-layout-container text-center'>
          <a
            href='http://www.netki.com'
            target='_blank'
            rel='noopener noreferrer'
            style={{ display: 'flex', justifyContent: 'center' }}
          >
            <img src={'/nk-logo.svg'} alt='' style={styles.logo} />
          </a>
          <div>{Component}</div>
        </div>
      </div>
      <div className='col-sm-7' style={responsiveStyles.containerRight}>
        <div style={styles.quotes}>
          <div style={styles.quotesOne}>Welcome to the</div>
          <div style={styles.quotesTwo}>Compliance Dashboard</div>
          <div style={styles.quotesThree}>
            <div>Onboarding Your Customers</div>
            <div>Has Never Been So Easy</div>
          </div>
        </div>
        <div style={styles.landingFooter}>
          <div className='pull-right'>{process.env.REACT_APP_VERSION ? `v${process.env.REACT_APP_VERSION}` : ''}</div>
        </div>
      </div>
    </div>
  )
}
